import React from 'react';
import { Facebook, Instagram, Linkedin } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useLaunch } from '../contexts/LaunchContext';
import { COMPANY, SUPPORT_EMAIL } from '../data/launch';
export function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isPublicLaunch
  } = useLaunch();
  const scrollToSection = (id: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-gray-950 pt-16 pb-8 border-t-2 border-kitty-yellow" data-id="element-73" data-mp="3qcx8kbgauo39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74" data-mp="29z6x2jmuoxjl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-75" data-mp="29xvrqfdrbhqd">
          <div className="col-span-1 md:col-span-2" data-id="element-76" data-mp="2ezb99xgq7640">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-77" data-mp="3l9k65dxrvpdt">
              <div className="bg-white rounded-lg w-10 h-10 flex items-center justify-center" data-id="element-78" data-mp="3l9sjf6xt4wpj">
                <img src="https://cdn.magicpatterns.com/uploads/vpaWAD2nLEfW1hoAd36jz7/LPot_only.png" alt="" className="w-[26px] h-[26px] object-contain" data-id="element-79" data-mp="3gc0ixoj3k29q" />
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-80" data-mp="82qtvx6261vu">
                KittyPot
              </span>
            </Link>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-81" data-mp="335trjf5jnhj">
              KittyPot helps groups track shared expenses, split costs fairly
              and keep track of who owes what.
            </p>
            <div className="flex gap-4" data-id="element-82" data-mp="cv1qaq1lb5jn">
              <a href="https://www.linkedin.com/company/kitty-pot/?viewAsMember=true" target="_blank" rel="noopener noreferrer" aria-label="KittyPot on LinkedIn" className="w-10 h-10 rounded-full bg-white/[0.06] flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/[0.1] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow" data-id="element-83" data-mp="cw35n6pn2e76">
                <Linkedin className="w-5 h-5" aria-hidden="true" data-id="element-84" data-mp="13r7m2y4vwkn7" />
              </a>
              <a href="https://www.facebook.com/people/Kittypotapp/100089385062763/" target="_blank" rel="noopener noreferrer" aria-label="KittyPot on Facebook" className="w-10 h-10 rounded-full bg-white/[0.06] flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/[0.1] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow" data-id="element-85" data-mp="18lkbdot1kq6v">
                <Facebook className="w-5 h-5" aria-hidden="true" data-id="element-86" data-mp="3ocgi6ox89d6s" />
              </a>
              <a href="https://www.instagram.com/kittypotapp" target="_blank" rel="noopener noreferrer" aria-label="KittyPot on Instagram" className="w-10 h-10 rounded-full bg-white/[0.06] flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/[0.1] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow" data-id="element-87" data-mp="3t9gggdnu5bnc">
                <Instagram className="w-5 h-5" aria-hidden="true" data-id="element-88" data-mp="2tdzkmuvet5ua" />
              </a>
            </div>
          </div>

          <div data-id="element-89" data-mp="2pbutq3wcinbc">
            <h2 className="font-bold text-kitty-yellow mb-4" data-id="element-90" data-mp="2pc4i5n1qsmex">Product</h2>
            <ul className="space-y-3" data-id="element-91" data-mp="2kd1dw4tl6k80">
              <li data-id="element-92" data-mp="2kc02fz8nrvpr">
                <button onClick={() => scrollToSection('how-it-works')} className="text-gray-400 hover:text-white transition-colors text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow rounded" data-id="element-93" data-mp="2kbglakqu1bcs">
                  How it works
                </button>
              </li>
              <li data-id="element-94" data-mp="2rv7o9uxwjtzq">
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-white transition-colors text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow rounded" data-id="element-95" data-mp="2ruogh71yulzf">
                  Features
                </button>
              </li>
              <li data-id="element-96" data-mp="2nrrur7h4q9r9">
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors" data-id="element-97" data-mp="3bjzzxq4quwfd">
                  FAQ
                </Link>
              </li>
              <li data-id="element-98" data-mp="31m2bp2mvwzmr">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors" data-id="element-99" data-mp="31khiphg7xor0">
                  About us
                </Link>
              </li>
              <li data-id="element-100" data-mp="1q4sukmr8ajom">
                <button onClick={() => scrollToSection('get-started')} className="text-gray-400 hover:text-white transition-colors text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow rounded" data-id="element-101" data-mp="1q8gohn0l583v">
                  {isPublicLaunch ? 'Download KittyPot' : 'Join the waitlist'}
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-102" data-mp="1rnsvbia2wccf">
            <h2 className="font-bold text-kitty-yellow mb-4" data-id="element-103" data-mp="1rnb08oz5k463">Legal</h2>
            <ul className="space-y-3" data-id="element-104" data-mp="13xyjn41hwttr">
              <li data-id="element-105" data-mp="13z04g08bcuoo">
                <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors" data-id="element-106" data-mp="13yhyuczrh443">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-107" data-mp="1dpmd1ahm4kxv">
                <Link to="/delete-account" className="text-gray-400 hover:text-white transition-colors" data-id="element-108" data-mp="18wjjh2cu5bho">
                  Delete account
                </Link>
              </li>
              <li data-id="element-109" data-mp="g7mchve2r148">
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors" data-id="element-110" data-mp="g847ypswxbb3">
                  Terms of Use
                </Link>
              </li>
              <li data-id="element-111" data-mp="2l7doepgm0ilo">
                <Link to="/cookie-policy" className="text-gray-400 hover:text-white transition-colors" data-id="element-112" data-mp="2q0ozj2sgflje">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-113" data-mp="1xct0hrfexhjg">
                <Link to="/disclaimer" className="text-gray-400 hover:text-white transition-colors" data-id="element-114" data-mp="1xdcdquu4bhr5">
                  Disclaimer
                </Link>
              </li>
              <li data-id="element-115" data-mp="27cbk26rev1az">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-116" data-mp="2bbaozrd56y2f">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/[0.08] flex flex-col items-center gap-4 text-center" data-id="element-117" data-mp="3mowdrbf3axnf">
          <p className="text-gray-400 text-sm max-w-2xl" data-id="element-118" data-mp="1b5gkcml1i34j">
            KittyPot tracks shared expenses and settlement records. KittyPot
            does not hold or move money — group members settle up directly with
            each other.
          </p>
          <p className="text-gray-500 text-sm max-w-2xl" data-id="element-119" data-mp="xawdf3u8p63c">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="underline underline-offset-2 hover:text-gray-300 transition-colors" data-id="element-120" data-mp="scuv4l4n1asx">
              {SUPPORT_EMAIL}
            </a>
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 w-full mt-4" data-id="element-121" data-mp="jbodu9u5zvym">
            <p className="text-gray-500 text-sm" data-id="element-122" data-mp="edv79foy8zxt">
              © {COMPANY.copyrightYear} {COMPANY.legalName}. All rights
              reserved. Company Reg. {COMPANY.registrationNumber}
            </p>
            <p className="text-gray-500 text-sm" data-id="element-123" data-mp="28qusppg0god0">Designed in the UK 🇬🇧</p>
          </div>
        </div>
      </div>
    </footer>;
}